import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let empty = class empty extends Vue {
  async validate() {
    return true;
  }
};
empty = __decorate([Component({
  name: "empty",
  components: {}
})], empty);
export default empty;